// import React from 'react'
// import { Helmet } from 'react-helmet';

// export default function TitleServices() {

// const serviceCategories = [
//   {
//     category: "Title Services",
//     description:
//       "Our Title Services deliver expert analysis and protection throughout the property ownership journey, safeguarding transactions by confirming clear, marketable title and revealing any hidden risks or defects in advance.",
//     services: [
//       {
//         name: "Current Owner Search",
//         details:
//           "Confirms the present legal ownership of the property, validates title standing, and highlights any active liens, claims, or restrictions that could influence the current holder's rights."
//       },
//       {
//         name: "Two-Owner Search",
//         details:
//           "Reviews the chain of title for the existing owner and the immediately preceding one, identifying issues or defects that may have arisen during the recent transfer of ownership."
//       },
//       {
//         name: "Full Title Search",
//         details:
//           "Conducts an exhaustive review of the property’s complete ownership history from its origin to today, mapping the full chain of title along with all recorded liens, encumbrances, easements, and other interests."
//       },
//       {
//         name: "Foreclosure Search",
//         details:
//           "Detects any ongoing or completed foreclosure processes, notices of default, or related legal actions that might jeopardize clear title or ownership transfer."
//       },
//       {
//         name: "Judgment Search",
//         details:
//           "Reveals court-issued monetary judgments, liens, or adverse legal decisions against current or former owners that could attach to the property and create clouds on title."
//       },
//       {
//         name: "Bankruptcy Search",
//         details:
//           "Investigates federal bankruptcy filings by present or past owners to evaluate whether automatic stays, discharges, or trustee claims could affect property rights or marketability."
//       },
//       {
//         name: "Tax Lien Search",
//         details:
//           "Uncovers delinquent property taxes, special assessments, or governmental tax liens that may lead to forced sales or priority claims superior to other interests."
//       },
//       {
//         name: "UCC Search (Uniform Commercial Code)",
//         details:
//           "Examines filings under the UCC for personal property security interests or fixtures that might impact real estate, especially in transactions involving business assets or equipment."
//       },
//       {
//         name: "Prothonotary Search",
//         details:
//           "Analyzes civil court filings and dockets from the Prothonotary’s office to spot lawsuits, attachments, or proceedings that could impose restrictions or claims on the property."
//       },
//       {
//         name: "Chancery Court Search",
//         details:
//           "Searches equity and chancery court records for decrees, injunctions, partition actions, or equitable remedies that may alter property rights or usage."
//       },
//       {
//         name: "Superior Court Search",
//         details:
//           "Reviews records from state superior or trial courts for civil disputes, criminal matters involving property, or other judgments potentially affecting title integrity or parties involved."
//       },
//       {
//         name: "Easement & Restriction Search",
//         details:
//           "Locates documented easements, rights-of-way, covenants, conditions, and restrictions that govern property access, usage, development, or modifications."
//       },
//       {
//         name: "Environmental Lien Search",
//         details:
//           "Identifies federal or state environmental liens, superfund listings, or cleanup obligations tied to contamination, hazardous substances, or regulatory violations on or near the property."
//       },
//     ],
//   },
// ];


//   return (
//     <div className="bg-white">
//       <Helmet>
//         <meta charSet="utf-8" />
//         <title>CityPulse LLC | Title Services</title>
//         <link rel="canonical" href="https://citypulsellc.com/services" />
//       </Helmet>
//       {/* Header */}
//       <section className="relative bg-gradient-to-r from-primary to-primary-dark text-white py-20 overflow-hidden">
//         <div
//           className="absolute inset-0 bg-cover bg-center opacity-20"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
//           }}
//         ></div>
//         <div className="absolute inset-0 bg-gradient-to-r from-primary/95 to-primary-dark/95"></div>
//         <div className="absolute inset-0 bg-grid"></div>

//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="glass-card rounded-2xl p-8 md:p-12 inline-block">
//             <h1 className="text-5xl md:text-6xl font-bold mb-6 text-primary">Title Services</h1>
//             <p className="text-xl text-gray-700 max-w-3xl font-semibold">
//               Our Title Services are designed to ensure the security, validity, and legal clarity of property transactions throughout the title lifecycle.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Services Detail */}
//       <section className="py-20 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-6 space-y-20">

//           {serviceCategories.map((category, index) => (
//             <div key={index}>
//               {/* <h2 className="text-4xl font-bold text-primary mb-4">
//                 {category.category}
//               </h2>
//               <p className="text-lg text-gray-600 mb-10 max-w-3xl">
//                 {category.description}
//               </p> */}

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//                 {category.services.map((service, idx) => (
//                   <div
//                     key={idx}
//                     className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition"
//                   >
//                     <h3 className="text-xl font-semibold text-primary mb-3">
//                       {service.name}
//                     </h3>
//                     {service.details && (
//                       <p className="text-gray-700 leading-relaxed">
//                         {service.details}
//                       </p>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}

//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="relative py-20 bg-primary text-white overflow-hidden">
//         <div
//           className="absolute inset-0 bg-cover bg-center opacity-20"
//         // style={{
//         //   backgroundImage: `url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
//         // }}
//         ></div>
//         <div className="absolute inset-0 bg-primary/90"></div>
//         <div className="absolute inset-0 bg-grid"></div>

//         <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <div className="glass-card rounded-2xl p-8 md:p-12">
//             <h2 className="text-4xl font-bold mb-6 text-primary">
//               Ready to Get Started?
//             </h2>
//             <p className="text-xl text-gray-700 mb-8 font-semibold">
//               Contact us today to learn how City Pulse can support your mortgage processing needs.
//             </p>
//             <a
//               href="/contact"
//               className="inline-block glass bg-accent/90 hover:bg-accent text-primary hover:text-white font-semibold py-3 px-8 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg"
//             >
//               Contact Us
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   )
// }



import React from 'react'
import { Helmet } from 'react-helmet';

export default function TitleServices() {

    const serviceCategories = [
        {
            category: "Title Services",
            description:
                "Our Title Services deliver expert analysis and protection throughout the property ownership journey, safeguarding transactions by confirming clear, marketable title and revealing any hidden risks or defects in advance.",
            services: [
                {
                    name: "Current Owner Search",
                    icon: "🏠",
                    details:
                        "Confirms the present legal ownership of the property, validates title standing, and highlights any active liens, claims, or restrictions that could influence the current holder's rights."
                },
                {
                    name: "Two-Owner Search",
                    icon: "👥",
                    details:
                        "Reviews the chain of title for the existing owner and the immediately preceding one, identifying issues or defects that may have arisen during the recent transfer of ownership."
                },
                {
                    name: "Order Entry or Open Order",
                    icon: "📜",
                    details:
                        "Creating and setting up new title orders with accurate property, buyer, seller, and lender information to initiate the title process."
                },
                {
                    name: "Full Title Search",
                    icon: "🔍",
                    details:
                        "Conducts an exhaustive review of the property's complete ownership history from its origin to today, mapping the full chain of title along with all recorded liens, encumbrances, easements, and other interests."
                },
                {
                    name: "Foreclosure Search",
                    icon: "⚠️",
                    details:
                        "Detects any ongoing or completed foreclosure processes, notices of default, or related legal actions that might jeopardize clear title or ownership transfer."
                },
                {
                    name: "Judgment Search",
                    icon: "⚖️",
                    details:
                        "Reveals court-issued monetary judgments, liens, or adverse legal decisions against current or former owners that could attach to the property and create clouds on title."
                },
                {
                    name: "Bankruptcy Search",
                    icon: "📂",
                    details:
                        "Investigates federal bankruptcy filings by present or past owners to evaluate whether automatic stays, discharges, or trustee claims could affect property rights or marketability."
                },
                {
                    name: "Tax Lien Search",
                    icon: "🏛️",
                    details:
                        "Uncovers delinquent property taxes, special assessments, or governmental tax liens that may lead to forced sales or priority claims superior to other interests."
                },
                {
                    name: "UCC Search",
                    icon: "📋",
                    details:
                        "Examines filings under the UCC for personal property security interests or fixtures that might impact real estate, especially in transactions involving business assets or equipment."
                },
                {
                    name: "Prothonotary Search",
                    icon: "🗃️",
                    details:
                        "Analyzes civil court filings and dockets from the Prothonotary's office to spot lawsuits, attachments, or proceedings that could impose restrictions or claims on the property."
                },
                {
                    name: "Superior Court Search",
                    icon: "📜",
                    details:
                        "Reviews records from state superior or trial courts for civil disputes, criminal matters involving property, or other judgments potentially affecting title integrity or parties involved."
                },
                {
                    name: "Easement & Restriction Search",
                    icon: "🗺️",
                    details:
                        "Locates documented easements, rights-of-way, covenants, conditions, and restrictions that govern property access, usage, development, or modifications."
                },
                {
                    name: "Chancery Court Search",
                    icon: "🏛️",
                    details:
                        "Searches equity and chancery court records for decrees, injunctions, partition actions, or equitable remedies that may alter property rights or usage."
                },
                {
                    name: "Environmental Lien Search",
                    icon: "🌿",
                    details:
                        "Identifies federal or state environmental liens, superfund listings, or cleanup obligations tied to contamination, hazardous substances, or regulatory violations on or near the property."
                },
            ],
        },
    ];

    const stats = [
        { value: "13+", label: "Core Services" },
        { value: "Full", label: "Chain of Title" },
        { value: "100%", label: "Legal Clarity" },
        { value: "Zero", label: "Hidden Risks" },
    ];

    return (
        <div className="bg-white">
            <Helmet>
                <meta charSet="utf-8" />
                <title>CityPulse LLC | Title Services</title>
                <link rel="canonical" href="https://citypulsellc.com/services" />
            </Helmet>

            {/* ── HERO ── */}
            <section className="relative min-h-[60vh] flex flex-col justify-center overflow-hidden bg-gray-950">

                {/* Background photo */}
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                        backgroundImage: `url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
                    }}
                />
                {/* Layered overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-gray-950/85 via-gray-900/70 to-blue-900/50" />

                {/* Decorative blobs + dot grid */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-blue-500/20 blur-3xl" />
                    <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-indigo-500/10 blur-3xl" />
                    <div
                        className="absolute inset-0 opacity-10"
                        style={{
                            backgroundImage: `radial-gradient(circle, #fff 1px, transparent 1px)`,
                            backgroundSize: `32px 32px`,
                        }}
                    />
                </div>

                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">

                    {/* Eyebrow badge */}
                    <div className="flex items-center gap-3 mb-6">
                        <span className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-blue-300">
                            <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
                            City Pulse Services
                        </span>
                    </div>

                    {/* Headline */}
                    <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white leading-none mb-6 max-w-3xl">
                        Title
                        <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-300 mt-1">
                            Services
                        </span>
                    </h1>

                    {/* Accent divider */}
                    <div className="flex items-center gap-4 mb-6">
                        <div className="h-px w-16 bg-gradient-to-r from-blue-400 to-transparent" />
                        <div className="w-2 h-2 rounded-full bg-blue-400" />
                    </div>

                    {/* Description */}
                    <p className="text-lg sm:text-xl text-gray-300 max-w-2xl leading-relaxed mb-12">
                        Our Title Services are designed to ensure the security, validity, and legal clarity of property transactions throughout the title lifecycle.
                    </p>

                    {/* Stats row */}
                    {/* <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl">
                        {stats.map((stat, i) => (
                            <div
                                key={i}
                                className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl px-4 py-4 text-center hover:bg-white/10 transition-colors duration-200"
                            >
                                <div className="text-lg sm:text-2xl font-black text-white leading-tight">{stat.value}</div>
                                <div className="text-xs text-gray-400 mt-0.5 font-medium">{stat.label}</div>
                            </div>
                        ))}
                    </div> */}

                    {/* Scroll hint */}
                    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
                        <span className="text-white text-xs uppercase tracking-widest">Scroll</span>
                        <div className="w-px h-8 bg-gradient-to-b from-white to-transparent animate-bounce" />
                    </div>
                </div>
            </section>

            {/* ── SERVICES GRID ── */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    {/* Section label */}
                    <div className="flex items-center gap-3 mb-3">
                        <div className="h-px w-10 bg-blue-600" />
                        <span className="text-xs font-bold uppercase tracking-widest text-blue-700">What We Handle</span>
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
                        Our Title Capabilities
                    </h2>
                    <p className="text-gray-500 mb-12 max-w-2xl">
                        From ownership searches to environmental lien detection — comprehensive title protection at every step.
                    </p>

                    {serviceCategories.map((category, index) => (
                        <div key={index} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                            {category.services.map((service, idx) => (
                                <div
                                    key={idx}
                                    className="group bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl border border-gray-100 hover:border-blue-200 transition-all duration-300 flex flex-col gap-4"
                                >
                                    {/* Icon + Name */}
                                    <div className="flex justify-start items-center gap-3">
                                        <div className="flex-shrink-0 w-11 h-11 bg-blue-50 rounded-xl flex items-center justify-center text-xl group-hover:bg-blue-100 transition-colors">
                                            {service.icon}
                                        </div>
                                        <h3 className="text-base lg:text-lg 2xl:text-xl font-bold text-gray-900 leading-snug pt-1">
                                            {service.name}
                                        </h3>
                                    </div>

                                    {/* Divider */}
                                    <div className="h-px bg-gray-100 group-hover:bg-blue-100 transition-colors" />

                                    {/* Details */}
                                    {service.details && (
                                        <p className="text-sm lg:text-base text-gray-800 leading-relaxed flex-1">
                                            {service.details}
                                        </p>
                                    )}

                                    {/* Tag */}
                                    {/* <div className="self-start">
                                        <span className="text-xs font-semibold text-blue-700 bg-blue-50 px-2.5 py-1 rounded-full">
                                            Title
                                        </span>
                                    </div> */}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </section>

            {/* ── CTA SECTION ── */}
            <section className="relative py-20 overflow-hidden bg-gray-950">
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-blue-500/20 blur-3xl -translate-y-1/2 translate-x-1/2" />
                    <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-indigo-500/15 blur-3xl translate-y-1/2 -translate-x-1/4" />
                    <div
                        className="absolute inset-0 opacity-5"
                        style={{
                            backgroundImage: `radial-gradient(circle, #fff 1px, transparent 1px)`,
                            backgroundSize: `28px 28px`,
                        }}
                    />
                </div>

                <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <span className="inline-block text-xs font-bold uppercase tracking-widest text-blue-400 mb-4">
                        Let's Work Together
                    </span>
                    <h2 className="text-4xl sm:text-5xl font-black text-white mb-4 leading-tight">
                        Ready to Get Started?
                    </h2>
                    <div className="w-16 h-1 bg-gradient-to-r from-blue-400 to-indigo-300 rounded-full mx-auto mb-6" />
                    <p className="text-lg text-gray-400 mb-10 max-w-xl mx-auto leading-relaxed">
                        Contact us today to learn how City Pulse can support your mortgage processing needs.
                    </p>
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                        <a
                            href="/contact"
                            className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-semibold py-3.5 px-8 rounded-xl transition-all duration-200 hover:scale-105 shadow-xl shadow-primary/30 text-sm"
                        >
                            Contact Us
                            <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none">
                                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                        <a
                            href="/services"
                            className="inline-flex items-center gap-2 border border-white/20 hover:border-white/40 text-gray-300 hover:text-white font-semibold py-3.5 px-8 rounded-xl transition-all duration-200 text-sm"
                        >
                            View All Services
                        </a>
                    </div>
                </div>
            </section>
        </div>
    )
}